import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import TableSection from "../TableSection";
import { formatBRL, formatNumber, formatHours, formatDays } from "../utils/formatters";

export default function PedidosEntregasTab({
  orderCompletionTime,
  cancellationRate,
  salesByRegion
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* Métricas de tempo de conclusão */}
      <Paper elevation={1} sx={{ p: 3, borderRadius: 2 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#1a237e' }}>
          Tempo de Conclusão dos Pedidos
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: '#607d8b' }}>
          Métricas de tempo de ciclo do pedido: preparação, envio, entrega, etc.
        </Typography>
        
        {orderCompletionTime && orderCompletionTime.totalCompletionMetrics ? (
          <Box>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={6} md={3}>
                <Paper elevation={0} sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2, textAlign: 'center' }}>
                  <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Tempo Médio Total</Typography>                  <Typography variant="h5" fontWeight={600} color="primary">
                    {formatHours(orderCompletionTime.totalCompletionMetrics.averageHours)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {formatDays(orderCompletionTime.totalCompletionMetrics.averageDays)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper elevation={0} sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2, textAlign: 'center' }}>
                  <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Tempo Mínimo</Typography>                  <Typography variant="h5" fontWeight={600} color="success.main">
                    {formatHours(orderCompletionTime.totalCompletionMetrics.minHours)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper elevation={0} sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2, textAlign: 'center' }}>
                  <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Tempo Máximo</Typography>                  <Typography variant="h5" fontWeight={600} color="error.main">
                    {formatHours(orderCompletionTime.totalCompletionMetrics.maxHours)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper elevation={0} sx={{ p: 2, backgroundColor: '#f5f5f5', borderRadius: 2, textAlign: 'center' }}>
                  <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Total de Pedidos</Typography>
                  <Typography variant="h5" fontWeight={600}>
                    {orderCompletionTime.totalOrders}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
            
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Detalhamento por Fase</Typography>
            <TableSection
              showTitle={false}              columns={[
                { field: "phase", headerName: "Fase" },
                { field: "averageHours", headerName: "Média (h)", format: (v) => formatNumber(v, 1) },
                { field: "minHours", headerName: "Mín (h)", format: (v) => formatNumber(v, 1) },
                { field: "maxHours", headerName: "Máx (h)", format: (v) => formatNumber(v, 1) },
                { field: "averageMinutes", headerName: "Média (min)", format: (v) => formatNumber(v, 0) },
              ]}
              rows={[
                { phase: "Preparação", ...orderCompletionTime.processingPhases.preparation },
                { phase: "Processo de Envio", ...orderCompletionTime.processingPhases.shippingProcess },
                { phase: "Entrega", ...orderCompletionTime.processingPhases.delivery },
                { phase: "Manuseio até Entrega", ...orderCompletionTime.processingPhases.handlingToDelivery },
              ]}
              emptyMessage="Nenhum dado disponível"
            />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
            <Typography variant="body1" color="text.secondary">Nenhum dado disponível para o período selecionado</Typography>
          </Box>
        )}
      </Paper>
      
      {/* Taxa de cancelamento */}
      <Paper elevation={1} sx={{ p: 3, borderRadius: 2 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#1a237e' }}>
          Taxa de Cancelamento de Pedidos
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: '#607d8b' }}>
          Análise da taxa de cancelamento de pedidos no período selecionado.
        </Typography>
        
        {cancellationRate ? (
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Box sx={{ p: 3, textAlign: 'center', borderRadius: 2 }}>
                <Typography variant="h3" fontWeight={700} color={
                  cancellationRate.cancellationRate > 10 ? "error.main" : 
                  cancellationRate.cancellationRate > 5 ? "warning.main" : "success.main"
                }>
                  {formatNumber(cancellationRate.cancellationRate)}%
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Taxa de Cancelamento
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography variant="body1">Total de Pedidos:</Typography>
                  <Typography variant="h6" fontWeight={600}>{cancellationRate.totalOrders}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography variant="body1">Pedidos Cancelados:</Typography>
                  <Typography variant="h6" fontWeight={600} color="error.main">{cancellationRate.canceledOrders}</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
            <Typography variant="body1" color="text.secondary">Nenhum dado disponível para o período selecionado</Typography>
          </Box>
        )}
      </Paper>
      
      {/* Vendas por região - Mapa
      <Paper elevation={1} sx={{ p: 3, borderRadius: 2 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#1a237e' }}>
          Distribuição Geográfica de Vendas
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: '#607d8b' }}>
          Visualize a distribuição de vendas e receita por estado/região do Brasil.
        </Typography>
        
        {salesByRegion && salesByRegion.length > 0 ? (
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <Box sx={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                  [Mapa do Brasil com destaque para estados com mais vendas]
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={5}>
              <TableSection
                showTitle={false}
                columns={[
                  { field: "state", headerName: "Estado" }, 
                  { field: "orderCount", headerName: "Pedidos", format: (v) => formatNumber(v, 0) }, 
                  { field: "totalRevenue", headerName: "Receita", format: (v) => formatBRL(v) }
                ]}
                rows={salesByRegion || []}
                emptyMessage="Nenhum dado disponível"
              />
            </Grid>
          </Grid>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
            <Typography variant="body1" color="text.secondary">Nenhum dado disponível para o período selecionado</Typography>
          </Box>
        )}
      </Paper> */}
    </Box>
  );
}
